/**
 *
 * @param duration
 */
export function isSpellDurationContract(duration) {
    return duration.durationType !== undefined;
}
